import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { enableDirectApi, getApiBaseUrl, PRODUCTION_API_BASE } from '../config/api.config';

export type ApiAxiosConfig = InternalAxiosRequestConfig & { __apiFallback?: boolean };

export function applyApiBaseUrl(config: ApiAxiosConfig): void {
  if (config.__apiFallback || getApiBaseUrl() === PRODUCTION_API_BASE) {
    config.baseURL = PRODUCTION_API_BASE;
  } else {
    config.baseURL = getApiBaseUrl();
  }
}

export function shouldFallbackFromProxy(error: AxiosError): boolean {
  const config = error.config as ApiAxiosConfig | undefined;
  if (!config || config.__apiFallback) {
    return false;
  }
  if (!getApiBaseUrl().startsWith('/')) {
    return false;
  }

  const status = error.response?.status;
  // Only switch to direct API when the storefront proxy responded but failed.
  // Network/timeouts often mean api.tropayment.com DNS is unreachable too — do not make it worse.
  return status === 502 || status === 504;
}

export function retryWithDirectApi<T>(config: ApiAxiosConfig, request: (cfg: ApiAxiosConfig) => Promise<T>): Promise<T> {
  enableDirectApi();
  config.__apiFallback = true;
  config.baseURL = PRODUCTION_API_BASE;
  return request(config);
}
